import { MouseEvent } from 'react'
import {
  Slide as SlideType,
  useLightboxState,
} from 'yet-another-react-lightbox'

import { getExternalImageURL } from '@/shared/ui'

type LightboxImageProps = {
  slide: SlideType
  roomName: string
}

export const Slide = ({ slide, roomName }: LightboxImageProps) => {
  const { currentIndex } = useLightboxState()

  const handleContextMenu = (event: MouseEvent<HTMLImageElement>) => {
    event.preventDefault()
  }

  return (
    <div className="relative flex h-full max-h-[80vh] w-full max-w-[80vw] items-center justify-center">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={getExternalImageURL({ src: slide.src })}
        alt={`${roomName} ${currentIndex + 1}번째 이미지`}
        className="max-h-full min-h-3/4 object-contain select-none"
        onContextMenu={handleContextMenu}
      />
    </div>
  )
}
